import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-search",
  "use": "rt-portal-search-usage",
  "viewBox": "32 -232 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"32 -232 1024 1024\" id=\"rt-portal-search\">\n<path d=\"M982.6,667.8L758.2,443.4c-1.6-1.6-1.8-4.2-0.4-6c21.7-26.9,39.4-56.5,53-88.5c19.4-46,29.2-94.7,29.2-144.9\n\ts-9.8-98.9-29.2-144.8C792,14.9,765.2-24.9,731-59c-34.2-34.2-73.9-61-118.2-79.7C566.9-158.2,518.2-168,468-168\n\ts-98.9,9.8-144.8,29.2C278.9-120,239.1-93.2,205-59c-34.2,34.2-61,73.9-79.7,118.2C105.8,105.1,96,153.8,96,204s9.8,98.9,29.2,144.8\n\tC144,393.1,170.8,432.9,205,467c34.2,34.2,73.9,61,118.2,79.7C369.1,566.2,417.8,576,468,576s98.9-9.8,144.8-29.2\n\tc32-13.5,61.6-31.3,88.5-53c1.8-1.5,4.4-1.3,6,0.4l224.4,224.4c12.5,12.5,32.7,12.5,45.2,0l5.6-5.6\n\tC995.1,700.5,995.1,680.3,982.6,667.8z M468,504c-165.4,0-300-134.6-300-300S302.6-96,468-96S768,38.6,768,204S633.4,504,468,504z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/search.svg
// module id = 1345
// module chunks = 72